import React from "react";
import styled, { css } from "styled-components";


export const InnerWrapper = styled.div(({ theme }) => css`
    display:flex;
    flex-direction: column;
    background-color: ${theme.palette.main.fieldWell};
    border-radius: 15px;
    padding: 30px 40px;

    .payment-options-list {
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 0 20px;
        font-weight: ${theme.fonts.headingWeight};

        @media only screen and (min-width: ${theme.breakpoints.S}) {
            flex-direction: row;
        }
    }

    .input-wrapper {
        padding-right: 10px;
    }

    .payment-options-subtitle {
        padding-top: 10px;
    }
`);

const OuterWrapper = styled.div`
    padding: 5px 0 20px;
`;

export const Wrapper = ({children}) => (
    <OuterWrapper>
        <InnerWrapper>
            {children}
        </InnerWrapper>
    </OuterWrapper>
);